import React from 'react'
import { StatusTag, Tooltip } from '@clickcease/cc-client-components-lib'
import { useGetPlansDetails } from 'Features/accountSettings/api/getPlansDetails'
import { useTranslation } from 'react-i18next'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTriangleExclamation } from '@fortawesome/pro-light-svg-icons'
import { IconProp } from '@fortawesome/fontawesome-svg-core'

export const PaymentStatusTag = () => {
  const { t } = useTranslation('accountSettings')
  const { data: details } = useGetPlansDetails()

  const paymentStatus = details?.status

  const showTag = paymentStatus === 'incomplete_expired' || paymentStatus === 'past_due'

  return showTag ? (
    <Tooltip tooltiptContent={t('plan_details.payment_tag_tooltip')}>
      <StatusTag
        iconLeft={<FontAwesomeIcon icon={faTriangleExclamation as IconProp} />}
        variant={'primaryAccent'}
      >
        {t('plan_details.payment_tag')}
      </StatusTag>
    </Tooltip>
  ) : (
    <></>
  )
}
